const randomNames = [
  "TruthUncaged",
  "CryptidFan94",
  "EchoFirestorm",
  "CuriousFollower",
  "ForestWhispers",
  "FogWatcher",
  "RageSpark",
  "MemeFiend",
  "TruthLeakerX",
  "CloutGoblin",
  "ConcernedAuntie93",
  "TruthTwister",
  "BuzzCrafter",
  "ClickbaitGuru",
  "DeepDiveDanny",
  "SpinCycleSally",
  "AltFactJack",
  "EchoBoomer",
  "HypeHijacker",
  "ViralVixen",
  "HotTakeHarry",
  "MemeInjector",
  "TrendWarp",
  "InfoStormer",
  "Trollsmith",
  "ConvoCranker",
  "FactoidFred",
  "BaitSnatcher",
  "NewsBender",
];

export const getRandomName = () =>
  randomNames[Math.floor(Math.random() * randomNames.length)];
